import React from 'react';
import { string } from 'prop-types';
import I18n from 'i18n-js';
import ticketTypeConfig from '../helpers/ticketTypeConfig';

const TicketTypeLabel = ({ type = '' }) => {
  const { icon } = ticketTypeConfig[type] ?? {};

  return (
    <span className="tickets-index-page__ticket-type-label">
      {icon}
      {I18n.t(`tickets.ticket_types.${type}`)}
    </span>
  );
};

TicketTypeLabel.propTypes = {
  type: string,
};

export default TicketTypeLabel;
